export const settingsConstants = {
  INITIAL_STATE: 'INITIAL_STATE',
  CRED_VALUE: 'CRED_VALUE',
  UPDATE_FORM_TOGGLE_STATUS: 'UPDATE_FORM_TOGGLE_STATUS',
  SET_VERFICATION_FORM_STATUS: 'SET_VERFICATION_FORM_STATUS',
  SET_NOTIFICATION_FORM_STATUS: 'SET_NOTIFICATION_FORM_STATUS',
  SET_INTEGRATION_STATUS: 'SET_INTEGRATION_STATUS',
  SET_ORG_DOCS_STATUS: 'SET_ORG_DOCS_STATUS',
  SET_UPDATED_EMAIL: 'SET_UPDATED_EMAIL',
  SET_CODE_ERROR: 'SET_CODE_ERROR',
  SET_SUCCESS: 'SET_SUCCESS',
  SET_COUNTRY_CODE: 'SET_COUNTRY_CODE',
  SET_PASSWORD_RESET_SUCCESS: 'SET_PASSWORD_RESET_SUCCESS',
  SET_EMAIL_TOGGLE: 'SET_EMAIL_TOGGLE',
  SET_PUSH_TOGGLE: 'SET_PUSH_TOGGLE',
  SET_APP_TOGGLE: 'SET_APP_TOGGLE',
  SET_GROUP_FORM_STATUS: 'SET_GROUP_FORM_STATUS',
  SET_GROUP_DETAILS: 'SET_GROUP_DETAILS',

  //Get User Details
  GET_USER_DETAILS: 'GET_USER_DETAILS',
  GET_USER_DETAILS_SUCCESS: 'GET_USER_DETAILS_SUCCESS',
  GET_USER_DETAILS_FAILURE: 'GET_USER_DETAILS_FAILURE',

  //Put Names
  PUT_NAMES_REQUEST: 'PUT_NAMES_REQUEST',
  PUT_NAMES_SUCCESS: 'PUT_NAMES_SUCCESS',
  PUT_NAMES_FAILURE: 'PUT_NAMES_FAILURE',

  //Put Email
  PUT_EMAIL: 'PUT_EMAIL',
  PUT_EMAIL_SUCCESS: 'PUT_EMAIL_SUCCESS',
  PUT_EMAIL_FAILURE: 'PUT_EMAIL_FAILURE',

  //Put Password
  PUT_PASSWORD: 'PUT_PASSWORD',
  PUT_PASSWORD_SUCCESS: 'PUT_PASSWORD_SUCCESS',
  PUT_PASSWORD_FAILURE: 'PUT_PASSWORD_FAILURE',

  //Put Password
  PUT_NUMBER: 'PUT_NUMBER',
  PUT_NUMBER_SUCCESS: 'PUT_NUMBER_SUCCESS',
  PUT_NUMBER_FAILURE: 'PUT_NUMBER_FAILURE',

  PUT_USER_INFO_REQUEST: 'PUT_USER_INFO_REQUEST',
  PUT_USER_INFO_SUCCESS: 'PUT_USER_INFO_SUCCESS',
  PUT_USER_INFO_FAILURE: 'PUT_USER_INFO_FAILURE',

  //Email Activation Code
  EMAIL_ACTIVATION_CODE_REQUEST: 'EMAIL_ACTIVATION_CODE_REQUEST',
  EMAIL_ACTIVATION_CODE_SUCCESS: 'EMAIL_ACTIVATION_CODE_SUCCESS',
  EMAIL_ACTIVATION_CODE_FAILURE: 'EMAIL_ACTIVATION_CODE_FAILURE',

  //Email Code Validation
  EMAIL_CODE_VALIDATION_REQUEST: 'EMAIL_CODE_VALIDATION_REQUEST',
  EMAIL_CODE_VALIDATION_SUCCESS: 'EMAIL_CODE_VALIDATION_SUCCESS',
  EMAIL_CODE_VALIDATION_FAILURE: 'EMAIL_CODE_VALIDATION_FAILURE',

  //Password reset key
  SET_PASSWORD_RESET_KEY_REQUEST: 'SET_PASSWORD_RESET_KEY_REQUEST',
  SET_PASSWORD_RESET_KEY_SUCCESS: 'SET_PASSWORD_RESET_KEY_SUCCESS',
  SET_PASSWORD_RESET_KEY_FAILURE: 'SET_PASSWORD_RESET_KEY_FAILURE',

  //Enable Disable all settings
  ENABLE_DISABLE_ALL_SETTINGS_REQUEST: 'ENABLE_DISABLE_ALL_SETTINGS_REQUEST',
  ENABLE_DISABLE_ALL_SETTINGS_SUCCESS: 'ENABLE_DISABLE_ALL_SETTINGS_SUCCESS',
  ENABLE_DISABLE_ALL_SETTINGS_FAILURE: 'ENABLE_DISABLE_ALL_SETTINGS_FAILURE',

  //Enable Disable all group settings
  ENABLE_DISABLE_ALL_GROUP_SETTINGS_REQUEST: 'ENABLE_DISABLE_ALL_GROUP_SETTINGS_REQUEST',
  ENABLE_DISABLE_ALL_GROUP_SETTINGS_SUCCESS: 'ENABLE_DISABLE_ALL_GROUP_SETTINGS_SUCCESS',
  ENABLE_DISABLE_ALL_GROUP_SETTINGS_FAILURE: 'ENABLE_DISABLE_ALL_GROUP_SETTINGS_FAILURE',

  //Get group list
  GET_GROUP_LIST_REQUEST: 'GET_GROUP_LIST_REQUEST',
  GET_GROUP_LIST_SUCCESS: 'GET_GROUP_LIST_SUCCESS',
  GET_GROUP_LIST_FAILURE: 'GET_GROUP_LIST_FAILURE',

  //Get default notification settings
  GET_DEFAULT_NOTIFICATION_SETTINGS_REQUEST: 'GET_DEFAULT_NOTIFICATION_SETTINGS_REQUEST',
  GET_DEFAULT_NOTIFICATION_SETTINGS_SUCCESS: 'GET_DEFAULT_NOTIFICATION_SETTINGS_SUCCESS',
  GET_DEFAULT_NOTIFICATION_SETTINGS_FAILURE: 'GET_DEFAULT_NOTIFICATION_SETTINGS_FAILURE',

  //Get notification settings
  GET_NOTIFICATION_SETTINGS_REQUEST: 'GET_NOTIFICATION_SETTINGS_REQUEST',
  GET_NOTIFICATION_SETTINGS_SUCCESS: 'GET_NOTIFICATION_SETTINGS_SUCCESS',
  GET_NOTIFICATION_SETTINGS_FAILURE: 'GET_NOTIFICATION_SETTINGS_FAILURE',

  //Update notification settings
  UPDATE_NOTIFICATION_SETTINGS_REQUEST: 'UPDATE_NOTIFICATION_SETTINGS_REQUEST',
  UPDATE_NOTIFICATION_SETTINGS_SUCCESS: 'UPDATE_NOTIFICATION_SETTINGS_SUCCESS',
  UPDATE_NOTIFICATION_SETTINGS_FAILURE: 'UPDATE_NOTIFICATION_SETTINGS_FAILURE',

  //Update language
  UPDATE_LANGUAGE_REQUEST: 'UPDATE_LANGUAGE_REQUEST',
  UPDATE_LANGUAGE_SUCCESS: 'UPDATE_LANGUAGE_SUCCESS',
  UPDATE_LANGUAGE_FAILURE: 'UPDATE_LANGUAGE_FAILURE',

  //account deactivatation/deletion
  DEACTIVATE_ACCOUNT_REQUEST: 'DEACTIVATE_ACCOUNT_REQUEST',
  DEACTIVATE_ACCOUNT_SUCCESS: 'DEACTIVATE_ACCOUNT_SUCCESS',
  DEACTIVATE_ACCOUNT_FAILURE: 'DEACTIVATE_ACCOUNT_FAILURE',

  REQUEST_TO_DELETE_ACCOUNT_REQUEST: 'REQUEST_TO_DELETE_ACCOUNT_REQUEST',
  REQUEST_TO_DELETE_ACCOUNT_SUCCESS: 'REQUEST_TO_DELETE_ACCOUNT_SUCCESS',
  REQUEST_TO_DELETE_ACCOUNT_FAILURE: 'REQUEST_TO_DELETE_ACCOUNT_FAILURE',

  CLEAR_DEACTIVATE_DATA: 'CLEAR_DEACTIVATE_DATA'
}
